/** Light haptic tap on phones/tablets that support it; silent everywhere else. */
export const haptic = (ms = 12) => {
  try {
    if (window.matchMedia("(pointer: coarse)").matches) navigator.vibrate?.(ms);
  } catch {}
};
